import { setUser } from "./identityActions";
import Config from "../Config";
import { authHeaderLicman, handleResponse } from "../helpers/requestHelpers";
import { history } from "../helpers/history";
import store from "../store";

const config = new Config();

function licmanFunctionsUrl(endpointName) {
    return config.apiUrl + `/${config.licmanModule}/` + endpointName;
}

export function updateShop(shop) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeaderLicman(), "Content-Type": "application/json" },
        body: JSON.stringify(shop),
    };

    return function (dispatch) {
        return fetch(licmanFunctionsUrl("updateShop"), requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function createShop(shop) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeaderLicman(), "Content-Type": "application/json" },
        body: JSON.stringify(shop),
    };

    return function (dispatch) {
        return fetch(licmanFunctionsUrl("createShop"), requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}

export function deployShop(licenseId, shopId) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeaderLicman(), "Content-Type": "application/json" },
        body: JSON.stringify({ licenseId: licenseId, licmanUrl: window.location.origin, shopId: shopId }),
    };

    return function (dispatch) {
        return fetch(licmanFunctionsUrl("deployShop"), requestOptions).then(async (response) => {
            if (response.ok) {
                const text = await response.text();
                if (!text) {
                    return {};
                }
                try {
                    return JSON.parse(text);
                } catch {
                    return {};
                }
            }
            if (response.status === 401) {
                store.dispatch(
                    setUser({
                        UserName: null,
                        Id: null,
                        Token: null,
                        Employee: null,
                    })
                );
                history.push("/login");
                const sessionErr = new Error("Unauthorized");
                sessionErr.status = 401;
                throw sessionErr;
            }
            let errBody = {};
            try {
                errBody = await response.json();
            } catch {
                errBody = {};
            }
            const apiMessage =
                errBody && typeof errBody.error === "string" && errBody.error.trim()
                    ? errBody.error.trim()
                    : `HTTP ${response.status}`;
            const deployErr = new Error(apiMessage);
            deployErr.status = response.status;
            deployErr.details = errBody.details;
            throw deployErr;
        });
    };
}

export function getAvailableShopVersions(shopKind) {
    const requestOptions = {
        method: "POST",
        headers: { ...authHeaderLicman(), "Content-Type": "application/json" },
        body: JSON.stringify(shopKind),
    };

    return function (dispatch) {
        return fetch(licmanFunctionsUrl("getAvailableShopVersions"), requestOptions)
            .then((response) => handleResponse(response))
            .then((json) => {
                return json;
            });
    };
}
